import { render, staticRenderFns } from "./ImportedActivityStatsPlaceholder.vue?vue&type=template&id=7f0c1f1e&scoped=true&"
import script from "./ImportedActivityStatsPlaceholder.vue?vue&type=script&lang=ts&"
export * from "./ImportedActivityStatsPlaceholder.vue?vue&type=script&lang=ts&"
import style0 from "./ImportedActivityStatsPlaceholder.vue?vue&type=style&index=0&id=7f0c1f1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0c1f1e",
  null
  
)

export default component.exports